import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { format } from 'date-fns';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SimpleSearchSelectComponent } from '../../simple-search-select/simple-search-select.component';
import { FormService } from '../../../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { BookingConfigService } from '../../../../../app/parkifly-bookings/services/booking-config.service';
import { AuthService } from '../../../../../app/services/auth.service';

@Component({
    selector: 'app-short-term-widget',
    standalone: false,
    templateUrl: './short-term-widget.component.html',
    styleUrl: './short-term-widget.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FormService]
})
export class ShortTermWidgetComponent implements OnInit {
    site: string = 'quality-xpo-arlanda';
    parkingStartTime: any;
    parkingEndTime: any;
    discountCodeControl = new FormControl('');
    org: string = "quality-xpo-arlanda";
    currentLang: string = 'sv';

    constructor(
        private router: Router,
        private _formService: FormService,
        private dialog: MatDialog,
        private authService: AuthService,
        private route: ActivatedRoute,
        private bookingConfigService: BookingConfigService,
        private translate: TranslocoService
    ) {
        this._formService.initForm(this.site);
        this.currentLang = this.translate.getActiveLang();
    }

    ngOnInit(): void {
        this.bookingConfigService.setOrganization(this.org);

        // Subscribe to form changes
        const search = this._formService.getForm().get('search');
        search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
            this.parkingEndTime = value;
        });
        search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
            this.parkingStartTime = value;
        });

        // Check query params for existing values
        this.route.queryParams.subscribe(params => {
            if (params['parking_start']) {
                this.parkingStartTime = new Date(params['parking_start']);
            }
            if (params['parking_end']) {
                this.parkingEndTime = new Date(params['parking_end']);
            }
        });
    }

    get isContinueButtonEnabled(): boolean {
        if (!this.parkingStartTime || !this.parkingEndTime || this.parkingEndTime <= this.parkingStartTime) {
            return false;
        }
        // Matching QualityXpoTwoDayBookingComponent logic for 2 days / 720 hours limit
        const diffInMs = this.parkingEndTime.getTime() - this.parkingStartTime.getTime();
        const diffInHours = diffInMs / (1000 * 60 * 60);
        return diffInHours <= 720;
    }

    goToBookingForm() {
        this.navigateToBooking();
    }

    navigateToBooking() {
        let parking_start = format(this.parkingStartTime, 'yyyy-MM-dd HH:mm');
        let parking_end = format(this.parkingEndTime, 'yyyy-MM-dd HH:mm');

        let queryParams: any = {
            parking_start,
            parking_end,
        };

        if (this.discountCodeControl.value?.length) {
            queryParams['discount_code'] = this.discountCodeControl.value;
        }

        const urlTree = this.router.createUrlTree(
            ['parkifly', 'quality-xpo-arlanda', 'booking', queryParams]
        );

        const relativeUrl = this.router.serializeUrl(urlTree);
        const fullUrl = window.location.origin + relativeUrl;
        window.open(fullUrl, '_blank');
    }

    setLanguage(lang: string) {
        this.currentLang = lang;
        this.translate.setActiveLang(lang);
    }
}
